import React, { useState } from 'react';
import PropTypes from 'prop-types';
import range from 'lodash/range';
import {
  IonText,
  IonIcon,
  IonItem,
  IonLabel,
  IonList,
  IonRadioGroup,
  IonRadio,
  IonPopover,
  IonListHeader,
} from '@ionic/react';
import { caretDown } from 'ionicons/icons';

function PortionSelect({ value, max, unpaidUsers, onChange }) {
  const [event, setEvent] = useState(undefined);

  return (
    <IonList>
      <IonListHeader>
        <IonLabel>How many people would you like to pay for?</IonLabel>
      </IonListHeader>
      <IonItem button onClick={(e) => setEvent(e.nativeEvent)}>
        <IonLabel>
          <IonText>{value === max ? 'Full Tab' : value}</IonText>
        </IonLabel>
        <IonIcon slot="end" icon={caretDown} />
      </IonItem>
      <IonPopover isOpen={!!event} onDidDismiss={() => setEvent(null)}>
        <IonList>
          <IonRadioGroup
            value={value}
            onIonChange={(e) => {
              setEvent(null);
              onChange(e.detail.value);
            }}
          >
            {range(1, max).map((i) => (
              <IonItem key={i} lines={i === max - 1 ? 'full' : 'none'}>
                <IonLabel>{i}</IonLabel>
                <IonRadio slot="end" value={i} disabled={unpaidUsers < i} />
              </IonItem>
            ))}
            <IonItem lines="none">
              <IonLabel>Full Tab</IonLabel>
              <IonRadio slot="end" value={max} disabled={unpaidUsers !== max} />
            </IonItem>
          </IonRadioGroup>
        </IonList>
      </IonPopover>
    </IonList>
  );
}

PortionSelect.propTypes = {
  unpaidUsers: PropTypes.number,
  value: PropTypes.number,
  max: PropTypes.number,
  onChange: PropTypes.func,
};

export default PortionSelect;
